import React from "react";
import { Search, X, EyeOff, Users, Shield, Globe } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import type { VisibilityLevel } from "@/contexts/VisibilityContext";

export type FilterLevel = "all" | VisibilityLevel;

interface SearchFilterBarProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  filterLevel: FilterLevel;
  setFilterLevel: (level: FilterLevel) => void;
}

const filters: { key: FilterLevel; label: string; icon: React.ReactNode }[] = [
  { key: "all", label: "All", icon: null },
  { key: "public", label: "Public", icon: <Globe className="h-3 w-3" /> },
  { key: "hidden", label: "Hidden", icon: <EyeOff className="h-3 w-3" /> },
  { key: "member", label: "Member", icon: <Users className="h-3 w-3" /> },
  { key: "admin", label: "Admin", icon: <Shield className="h-3 w-3" /> },
];

export function SearchFilterBar({
  searchQuery,
  setSearchQuery,
  filterLevel,
  setFilterLevel,
}: SearchFilterBarProps) {
  return (
    <div className="sticky top-0 z-10 bg-background pb-4 space-y-3">
      {/* Search Input */}
      <div className="relative">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search pages or sections..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-10 pr-10"
        />
        {searchQuery && (
          <Button
            variant="ghost"
            size="sm"
            className="absolute right-1 top-1/2 -translate-y-1/2 h-7 w-7 p-0"
            onClick={() => setSearchQuery("")}
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>

      {/* Filter Pills */}
      <div className="flex gap-2 flex-wrap">
        {filters.map(({ key, label, icon }) => (
          <Button
            key={key}
            variant={filterLevel === key ? "default" : "outline"}
            size="sm"
            onClick={() => setFilterLevel(key)}
            className="gap-1"
          >
            {icon}
            {label}
          </Button>
        ))}
      </div>
    </div>
  );
}
